export enum ResampleIntervals {
  OneMinute = '1m',
  ThreeMinutes = '3m',
  FiveMinutes = '5m',
  OneHour = '1h',
  TwoHours = '2h',
  ThreeHours = '3h',
  OneDay = '1D',
  OneWeek = '1W',
  OneMonth = '1M',
}

export enum RangeHorizon {
  OneDay = 'OneDay',
  OneWeek = 'OneWeek',
  OneMonth = 'OneMonth',
  ThreeMonths = 'ThreeMonths',
  SixMonths = 'SixMonths',
  OneYear = 'OneYear',
  ThreeYears = 'ThreeYears',
  FiveYears = 'FiveYears',
  TenYears = 'TenYears',
  Max = 'Max',
}

export const RANGE_HORIZON_DEFAULT = RangeHorizon.ThreeMonths;
export const RESAMPLE_DEFAULT = ResampleIntervals.OneDay;

export const rangeToResampleMapping = {
  [RangeHorizon.OneDay]: ResampleIntervals.OneMinute,
  [RangeHorizon.OneWeek]: ResampleIntervals.FiveMinutes,
  [RangeHorizon.OneMonth]: ResampleIntervals.OneHour,
  [RangeHorizon.ThreeMonths]: ResampleIntervals.OneDay,
  [RangeHorizon.SixMonths]: ResampleIntervals.OneDay,
  [RangeHorizon.OneYear]: ResampleIntervals.OneDay,
  [RangeHorizon.ThreeYears]: ResampleIntervals.OneWeek,
  [RangeHorizon.FiveYears]: ResampleIntervals.OneWeek,
  [RangeHorizon.TenYears]: ResampleIntervals.OneMonth,
  [RangeHorizon.Max]: ResampleIntervals.OneMonth,
};
